import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from '../../config/env';
import { removeEmpty } from '../../utils/object';

export const projectApi = createApi({
  reducerPath: 'projectApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }), // base URL
  endpoints: (builder) => ({
    getStates: builder.query({
      query: () => 'location/states',
    }),
    getProjects: builder.query({
      query: (params = {}) => {
        const { clientId, search } = params || {};
        const query = removeEmpty({ client_id: clientId, search });

        return {
          url: 'project',
          ...(Object.keys(query).length > 0 && { params: query }),
        };
      },
      providesTags: ['Projects'],
    }),
    getProjectStates: builder.query({
      query: ({ projectId }) => `project/${projectId}/states`,
    }),
    getProjectDistricts: builder.query({
      query: ({ projectId, stateId }) => ({
        url: `project/${projectId}/districts`,
        params: stateId ? { state_id: stateId } : {},
      }),
    }),
    getProjectSubDistricts: builder.query({
      query: ({ projectId, districtId }) => ({
        url: `project/${projectId}/sub-districts`,
        params: districtId ? { district_id: districtId } : {},
      }),
    }),
    getProjectVillageFilters: builder.query({
      query: ({ projectId, subDistrictId }) => ({
        url: `project/${projectId}/villages`,
        params: subDistrictId ? { sub_district_id: subDistrictId } : {},
      }),
    }),
    getProjectCrops: builder.query({
      query: ({ projectId }) => ({
        url: `project/${projectId}/crops`,
      }),
    }),
    getCropInfestations: builder.query({
      query: (params = {}) => {
        const normalized = params || {};
        const cropIds = Array.isArray(normalized.cropIds)
          ? normalized.cropIds.filter(Boolean)
          : [];
        const searchParams = new URLSearchParams();

        cropIds.forEach((cropId) => {
          searchParams.append('crop_ids', cropId);
        });

        return {
          url: `infestation/crop-infestations?${searchParams.toString()}`,
        };
      },
    }),
    getDistricts: builder.mutation({
      query: (state) => ({
        url: 'location/districts',
        method: 'POST',
        body: state,
      }),
    }),
    getSubDistricts: builder.mutation({
      query: (districts) => ({
        url: 'location/sub-districts',
        method: 'POST',
        body: districts,
      }),
    }),
    getProjectFilters: builder.query({
      query: (args = {}) => {
        const params = removeEmpty(args);
        return {
          url: `project/filters`,
          ...(Object.keys(params).length > 0 && { params: params }),
        };
      },
    }),
    postProject: builder.mutation({
      query: (newProject) => {
        return {
          url: 'project',
          method: 'POST',
          body: newProject,
        };
      },
      invalidatesTags: ['Projects'],
    }),
    updateProject: builder.mutation({
      query: ({ id, updatedProject }) => ({
        url: `project/${id}`,
        method: 'PUT',
        body: updatedProject,
      }),
      invalidatesTags: ['Projects'],
    }),
    //  updateClient: builder.mutation({// Update Client
    //   query: ({ id, updatedClient }) =>{

    //     return ({
    //     url: `client/${id}`,
    //     method: 'PUT',
    //     body: {...updatedClient},
    //   })},
    // }),
  }),
});

export const {
  useGetStatesQuery,
  useGetProjectsQuery,
  useGetProjectStatesQuery,
  useGetProjectDistrictsQuery,
  useGetProjectSubDistrictsQuery,
  useGetProjectCropsQuery,
  useGetCropInfestationsQuery,
  useGetDistrictsMutation,
  useGetSubDistrictsMutation,
  useGetProjectVillageFiltersQuery,
  useGetProjectFiltersQuery,
  usePostProjectMutation,
  useUpdateProjectMutation,
} = projectApi;
